module.exports = __webpack_public_path__ + "img/Clément Lesaege.74002b6c.jpg";